import { twMerge } from "tailwind-merge";
import {
  Button,
  Card,
  CardContent,
  CardHeader,
  DataButton,
  H3,
  H5,
  H6,
} from "@sellar-io/components";
import { SupplierRelationshipGetResponseType } from "@sellar-io/api-v2/types";
import { useState } from "react";
import { Icon, SpinnerLegacy } from "../../../components";
import { useIntegrationList } from "../../../hooks/api/v2/integration/useIntegrationList";
import { ConnectionIntegrationModal } from "./connectionSelector/ConnectionIntegrationModal";
import {
  getIntegrationName,
  getIntegrationPlaceholder,
} from "./connectionSelector/ConnectionIntegrationValuesRow.shared";
import { useRemoteFeatureFlags } from "../../../hooks/useRemoteFeatureFlags";

export const ConnectionIntegrationMappingCard = ({
  connection,
}: {
  connection: SupplierRelationshipGetResponseType;
}) => {
  const editCustomerV2Enabled =
    useRemoteFeatureFlags().isActive("editCustomerV2");

  const integrationQuery = useIntegrationList({
    query: [
      {
        type: "supplierRetailerConnectionId",
        value: connection.id,
        modifier: "EQUALS",
      },
    ],
  });

  const [integrationModalActive, setIntegrationModalActive] = useState(false);

  if (integrationQuery.isPending) return <SpinnerLegacy />;

  if (integrationQuery.isError) return <span>Something went wrong...</span>;

  return (
    <>
      <Card className="bg-white">
        <CardHeader
          className={twMerge("bg-white", "flex items-center justify-between")}
        >
          <div>
            <H3>Customer mapping</H3>
            <H6>Keep your customers in sync across your integrations</H6>
          </div>

          {editCustomerV2Enabled ? (
            <DataButton
              border={true}
              onClick={() => setIntegrationModalActive(true)}
            >
              <Icon icon={"PENCIL"} />
              Edit
            </DataButton>
          ) : (
            <Button
              color={"secondary"}
              onClick={() => setIntegrationModalActive(true)}
            >
              <Icon icon={"PENCIL"} />
              Edit
            </Button>
          )}
        </CardHeader>
        <CardContent className={"grid grid-cols-2 gap-y-4"}>
          <div>
            {integrationQuery.data.pages.map((page) =>
              page.map((integration) => (
                <div key={integration.id}>
                  <H5>{`${getIntegrationName(
                    integration,
                  )} '${getIntegrationPlaceholder(integration)}'`}</H5>
                  {integration.SupplierRetailerConnectionIntegrationValues[0]
                    ?.value ?? "N/A"}
                </div>
              )),
            )}
          </div>
        </CardContent>
      </Card>
      <ConnectionIntegrationModal
        active={integrationModalActive}
        onDismiss={() => setIntegrationModalActive(false)}
        connection={connection}
      />
    </>
  );
};
